module.exports = __webpack_public_path__ + "img/lluvia_gray.d62c4b2d.svg";